const getInitialLetters = (name) => {
  if (name && name.length) {
    const nameParts = name.split(' ');

    if (nameParts && nameParts.length) {
      let letters = nameParts[0].charAt(0);

      if (nameParts.length > 1) {
        letters = `${letters}${nameParts[nameParts.length - 1].charAt(0)}`;
      }

      return letters.toUpperCase();
    }
  }

  return 'HC';
};

export default getInitialLetters;
